(function () {
    var NAMESPACE = 'a3320',
        NETWORK_ID = 3320,
        URL_TRACKING_ALLOWED = false,
        SITE_ID = '0',
        LOG_URL = (location.protocol == 'https:') ? 'https://www.econda-monitor.de/els/logging' : 'http://www.econda-monitor.de/els/logging',
        JUNK_SIZE = 1600,
        PROTOKOLL_VERSION = '2',
        CLIENT_COOKIE_LIFETIME = 2592000,
        COOKIENAME_SESSION_ID = 'emos_jcsid',
        SESSION_COOKIES_DISABLED = 'NULL',
        COOKIENAME_VISITOR_ID = 'emos_jcvid',
        PERSISTENT_COOKIES_DISABLED = 'NULL',
        COOKIENAME_CAMPAIGN = 'emos_jckamp',
        COOKIE_DOMAIN = null,
        TRACK_FIRSTPARTY = true,
        TRACK_POSTCONVERSION = true,
        EVENT_MILLIS = 200,
        TRACK_THIRD_PARTY = true,
        ca = 0,
        ak,
        be = 0,
        bk = 1,
        bv = 0,
        ah = 1,
        bi,
        bh,
        bg = 0,
        co = 0,
        w,
        ev,
        at,
        ad,
        h = null,
        as = [],
        trackPageLoads = true;

    window[NAMESPACE] = {}; var fq = (window.encodeURIComponent) ? window.encodeURIComponent : window.escape,
        f = function (s) {
            try { if (window.decodeURIComponent) { try { s = window.decodeURIComponent(s); } catch (e1) { s = window.unescape(s); } } else s = window.unescape(s); } catch (e) {}s = s.replace(/\+/g, ' ');

            return s;
        }; var en = function (submitData, requestId, y, m) {
            var gl = Math.floor(submitData.length / JUNK_SIZE) + 1,
                v = [];

            for (var i = 0; i < gl; i++) {
                v[i] = {}; v[i].v = PROTOKOLL_VERSION; v[i].emrid = requestId; if (TRACK_FIRSTPARTY == true) { v[i].emsid = be; v[i].emvid = bv; } if (TRACK_THIRD_PARTY && TRACK_POSTCONVERSION) {
                    var s = am(h);

                    if (s.length > 0) { v[i].emcl = CLIENT_COOKIE_LIFETIME; v[i].emcc = s; }
                }v[i].emnc = gl; v[i].emtn = i + 1; v[i].emhost = location.hostname; v[i].emkd = NETWORK_ID; v[i].advid = y; v[i].advr = m ? 1 : 0; if (TRACK_THIRD_PARTY) { v[i].tpct = 1; }v[i].d = submitData.substr(i * JUNK_SIZE, JUNK_SIZE);
            }

            return v;
        }; var cz = function () {
            var a = {},
                bs = [];

            z(a); if (!trackPageLoads) return; ag(l(a), ak, 0);
        }; var z = function (a) { if (!a.content)a.content = document.title; w = new Date().getTime(); ak = ac(); cl(); if (!trackPageLoads) return; o(a); k(a); if (TRACK_FIRSTPARTY && !TRACK_THIRD_PARTY) { a.sPI = bk; a.lhVt = (ad) ? Math.floor(w - ad) : 'NULL'; a.lhId = (at) ? at : 'NULL'; a.vS = ah; if (bi)a.gf = bi; if (bh)a.recency = bh; a.vmon = bg / 100; } }; var o = function (a) {
            a.host = location.host.substring(0, 63); if (URL_TRACKING_ALLOWED)a.url = location.pathname.substring(0, 254); var g = 'NULL',
                p = 'NULL';

            try { g = top.document.referrer; } catch (exception) { g = document.referrer; } try { p = cc(g); g = cb(g); } catch (exception) { }a.ref = g; if (p != 'NULL') { a.refUrl = p; }a.jv = navigator.javaEnabled() ? 1 : 0; a.swsh = screen.width + 'x' + screen.height; a.siteid = SITE_ID; a.emosV = '40pt';
        }; var cc = function (au) {
            var cu = 'NULL';

            try {
                var u = bu(au);

                if (u.url) { cu = f(u.url); }
            } catch (exception) {}cu = cu.substring(0, 127);

            return cu;
        }; var cb = function (au) {
            try {
                if (au == null || au.length == 0) { au = 'http://unknown'; } if (au.substr(0, 4) != 'http') { au = 'http://' + au; } else {
                    var dv = au.split('/');

                    au = dv[0] + '/' + dv[1] + '/' + dv[2];
                }
            } catch (exception) { }

            return au.substring(0, 127);
        }; var ag = function (dz, requestId, waitMillis) {
            var y = window[NAMESPACE].advertiserId,
                m = window[NAMESPACE].advertiserRestricted;

            if (typeof y !== 'string' && typeof y !== 'number') return; if (typeof m !== 'boolean') return; var dd = en(dz, requestId, y, m);

            for (var i = 0; i < dd.length; i++) { ca = ca + 1; fh(dd[i], ca, waitMillis); }
        }; var fh = function (a, count, waitMillis) {
            var q = am(a),
                go = new Image();

            as[count] = go; go.onload = function () { as[count] = null; }; go.src = LOG_URL + '?' + q; var aw = new Date().getTime() + waitMillis;

            while (new Date().getTime() < aw) {}
        }; var am = function (a) {
            var q = '';

            for (var dp in a) {
                var t = typeof a[dp];

                if (t == 'string' || t == 'boolean' || t == 'number') { if (q != '')q += '&'; q += dp + '=' + fq(a[dp]); }
            }

            return q;
        }; var bz = function (ab) {
            var ae = ab.split('&'),
                a = {};

            for (var j = 0; j < ae.length; j++) {
                var el = ae[j].split('=');

                a[el[0]] = f(el[1]);
            }

            return a;
        }; var l = function (a) {
            var q = [];

            for (var dp in a) { if (q.length != 0)q[q.length] = 28; q = q.concat(eh(dp), [31], ch(a[dp], 29)); }

            return fy(q);
        }; var ch = function (value, separator) {
            if (typeof value === 'string') return eh(value); if (typeof value === 'number' || value == 'boolean') return eh('' + value); var dz = [];

            for (var i = 0; i < value.length; i++) { if (i != 0)dz[dz.length] = separator; dz = dz.concat(ch(value[i], 30)); }

            return dz;
        }; var cl = function () {
            if (!TRACK_FIRSTPARTY) { return; } var aq = true,
                value = bo(COOKIENAME_SESSION_ID);

            if (value && value.length > 0) {
                var ae = value.split(':');

                if (ae.length == 4) { be = ae[0]; bk = parseInt(ae[1]) + 1; at = ae[2]; ad = parseInt(ae[3]); if (!isNaN(bk) && !isNaN(ad)) { aq = false; if (ad == 0)ad = null; fz(COOKIENAME_SESSION_ID, be + ':' + bk + ':' + ak + ':' + w); } }
            } if (aq) {
                ad = null; at = null; var gn = ac(),
                    ab = gn + ':1:' + ak + ':' + w;

                fz(COOKIENAME_SESSION_ID, ab); var cg = bo(COOKIENAME_SESSION_ID);

                if (ab == cg) { be = gn; bk = 1; aq = true; } else { be = SESSION_COOKIES_DISABLED; bk = -1; aq = false; }
            } var value = bo(COOKIENAME_VISITOR_ID);

            if (value && value.length > 0) {
                var ae = value.split(':');

                if (ae.length == 5) {
                    bv = ae[0]; ah = parseInt(ae[1]) + ((aq) ? 1 : 0); var gf = ae[2],
                        av = parseInt(ae[3]);

                    if (aq) { bi = gf; bh = w - av; av = w; } else { bi = null; bh = null; }bg = co; var cf = parseInt(ae[4]);

                    if (!isNaN(cf))bg += cf; if (!isNaN(ah)) {
                        fz(COOKIENAME_VISITOR_ID, bv + ':' + ah + ':' + be + ':' + av + ':' + bg, 0x2fffffff);

                        return;
                    }
                }
            } var gm = be;

            bg = co; var ab = gm + ':1:' + be + ':' + w + ':' + bg;

            fz(COOKIENAME_VISITOR_ID, ab, 0x2fffffff); var cg = bo(COOKIENAME_VISITOR_ID);

            if (ab == cg) { bv = gm; ah = 1; } else { bv = PERSISTENT_COOKIES_DISABLED; ah = -1; }
        }; var bo = function (cookieName) {
            var bp = document.cookie.split(';'); var length = cookieName.length;

            for (var i = 0; i < bp.length; i++) {
                var e = bp[i];

                if (e.charAt(0) == ' ')e = e.substr(1); if (e.substr(0, length) == cookieName) {
                    var da = e.indexOf('=');

                    if (da < 0) continue;

                    return e.substring(da + 1);
                }
            }

            return null;
        }; var fz = function (name, value, lifetime) {
            var ai = name + '=' + value + ';path=/;';

            if (COOKIE_DOMAIN)ai = ai + 'domain=' + COOKIE_DOMAIN + ';'; if (lifetime)ai = ai + 'max-age=' + lifetime + ';expires=' + new Date(new Date().getTime() + lifetime * 1000).toGMTString() + ';'; document.cookie = ai;
        }; var dm = function (name) {
            var ai = name + '=;path=/;max-age=0;';

            if (COOKIE_DOMAIN)ai = ai + 'domain=' + COOKIE_DOMAIN + ';'; document.cookie = ai;
        }; var ac = function () {
        var ed = new Date().getTime(),
            es = ed & 0xFFFFFFFF,
            er = (ed / 0x100000000) & 0xFFFFFFFF,
            b = [];

        b[b.length] = er >>> 24; b[b.length] = er >>> 16 & 0xFF; b[b.length] = er >>> 8 & 0xFF; b[b.length] = er & 0xFF; b[b.length] = es >>> 24; b[b.length] = es >>> 16 & 0xFF; b[b.length] = es >>> 8 & 0xFF; b[b.length] = es & 0xFF; for (var i = 0; i < 4; i++) {
            var r = (0x100000000 * Math.random()) & 0xFFFFFFFF;

            b[b.length] = r >>> 24; b[b.length] = r >>> 16 & 0xFF; b[b.length] = r >>> 8 & 0xFF; b[b.length] = r & 0xFF;
        }

        return fy(b);
    }; var eh = function (t) {
        var d = [],
        cm = String.fromCharCode(237);

        if (cm.charCodeAt(0) < 0) {
        for (var n = 0; n < t.length; n++) {
            var c = t.charCodeAt(n);

            if (c > 0) { if (c >= 32) { d[d.length] = c; } } else { d[d.length] = (((256 + c) >> 6) | 192); d[d.length] = (((256 + c) & 63) | 128); }
        }
    } else {
        for (var n = 0; n < t.length; n++) {
            var c = t.charCodeAt(n);

            if (c < 128) { if (c >= 32) { d[d.length] = c; } } else if ((c > 127) && (c < 2048)) { d[d.length] = ((c >> 6) | 192); d[d.length] = ((c & 63) | 128); } else { d[d.length] = ((c >> 12) | 224); d[d.length] = (((c >> 6) & 63) | 128); d[d.length] = ((c & 63) | 128); }
        }
    }

        return d;
    }; var eo = function () {
    var b64s = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789*_',
        b64 = [];

    for (var i = 0; i < b64s.length; i++) { b64[i] = b64s.charAt(i); }ev = b64;
}; var fy = function (d) {
    var b64 = ev,
        r = [],
        i = 0,
        dl = d.length;

    if ((dl % 3) == 1) { d[d.length] = 0; d[d.length] = 0; } if ((dl % 3) == 2)d[d.length] = 0; while (i < d.length) { r[r.length] = b64[d[i] >> 2]; r[r.length] = b64[((d[i] & 3) << 4) | (d[i + 1] >> 4)]; r[r.length] = b64[((d[i + 1] & 15) << 2) | (d[i + 2] >> 6)]; r[r.length] = b64[d[i + 2] & 63]; i += 3; } if ((dl % 3) == 1)r[r.length - 1] = r[r.length - 2] = ''; if ((dl % 3) == 2)r[r.length - 1] = ''; var t = r.join('');

    return t;
}; var k = function (a) {
    var u,
        cw,
        ax = '',
        dk = 0;

    h = {}; try { u = bu(top.location.search); } catch (exception) { u = bu(location.search); } try { cw = top.document.referrer; } catch (exception) { cw = document.referrer; } var cv = cc(cw),
        ff = cb(cw);

    if (cv != 'NULL') { dk = 1; } var hasPubId = false,
        hasSeoPage = false,
        allChannelsActive = false,
        pubId = window[NAMESPACE].publisherId,
        seoPage = window[NAMESPACE].PageName,
        trackAllSources = window[NAMESPACE].trackAllChannels;

    if (typeof pubId === 'string' || typeof pubId === 'number')hasPubId = true; if (typeof seoPage === 'string')hasSeoPage = true; if (typeof trackAllSources === 'boolean' && trackAllSources == true)allChannelsActive = true; if (cw.length < 1 || cw == null) { ax = 'direct'; } else { if (ck(ff)) { ax = 'intern'; } else { if ((eg(cw, a) == true) || (ff.indexOf('images.google') >= 0)) { ax = 'suma'; h.smqp = a.smqp; h.ref = ff; h.source = ax; if (hasPubId) { h.pbid = pubId; } if (hasSeoPage) { h.refUrl = seoPage.substring(0, 254); } else { h.refUrl = location.href.substring(0, 254); } } else { ax = 'ref'; } } } if (ax != 'suma') { if (!allChannelsActive && hasPubId) { trackPageLoads = false; } else { if (allChannelsActive) { if (hasPubId) { a.pbid = pubId; if (hasSeoPage) { a.refUrl = seoPage.substring(0, 254); } else { a.refUrl = location.href.substring(0, 254); } } } } }a.osource = ax; a.source = ax; if (TRACK_FIRSTPARTY) {
        var cq = ea();

        if (cq) { for (var dp in cq) { a[dp] = cq[dp]; } }
    }
}; var ck = function (ff) { return (ff.split('/')[2] == location.host); }; var SEARCH_ENGINES = [['q', 'start', 1], ['p', 'b', 1], ['su', 'pageIndex', 10], ['query'], ['qry_str'], ['begriff'], ['words'], ['encquery'], ['qt'], ['terms']],
    eg = function (au, a) {
        var u;

        try { u = bu(au); } catch (e) { return false; } var ref = au.toLowerCase();

        for (var i = 0; i < SEARCH_ENGINES.length; i++) {
            var az = u[SEARCH_ENGINES[i][0]];

            if (az) {
                a.smqp = f(az); if (SEARCH_ENGINES[i].length == 3) {
                    var da = parseInt(u[SEARCH_ENGINES[i][1]]);

                    if (!isNaN(da))a.smstart = da * SEARCH_ENGINES[i][2];
                }

                return true;
            }
        }

        return false;
    }; var ea = function () {
        var dw = bo(COOKIENAME_CAMPAIGN),
            fd = am(h);

        if (fd != '') {
            fz(COOKIENAME_CAMPAIGN, fd, CLIENT_COOKIE_LIFETIME);

            return h;
        } else {
            if (dw && dw.length > 0) {
                var fc = bz(dw);

                if (fc.scnd && fc.scnd == '1') { carriesSecondaryCookie = true; }fc.postconv = '1';

                return fc;
            }
        }

        return null;
    }; var an = function () {
        if (COOKIE_DOMAIN == null) {
            var af = window.location.hostname.split('.'),
                al = af[af.length - 1],
                gl = (al == 'uk' || al == 'tr' || al == 'br' || (al == 'at' && af[af.length - 2] == 'co')) ? 3 : 2;

            if (isNaN(parseInt(al)) && af.length >= gl) { COOKIE_DOMAIN = ''; for (var i = af.length - gl; i < af.length; i++) { COOKIE_DOMAIN = COOKIE_DOMAIN + '.' + af[i]; } } else { COOKIE_DOMAIN = window.location.hostname; }
        }
    };

    window[NAMESPACE].trackEvent = function (a) {
        z(a); if (!trackPageLoads) return true; ag(l(a), ak, 0);

        return true;
    }; window[NAMESPACE].userEvent1 = function (shortcut, value) {
        var a = {};

        z(a); if (!trackPageLoads) return true; a[shortcut] = value; ag(l(a), ak, EVENT_MILLIS);

        return true;
    }; window[NAMESPACE].userEvent2 = function (shortcut, value1, value2) {
        var a = {};

        z(a); if (!trackPageLoads) return true; a[shortcut] = [[value1, value2]]; ag(l(a), ak, EVENT_MILLIS);

        return true;
    }; window[NAMESPACE].targetEvent = function (tid, tlabel, covinfo) {
        var a = {};

        z(a); if (!trackPageLoads) return true; a.Target = [[tid, tlabel]]; a.cGoal = '1'; ag(l(a), ak, EVENT_MILLIS);

        return true;
    }; window[NAMESPACE].userEvent = function (type, param1, param2) {
        var a = {};

        z(a); if (!trackPageLoads) return true; a.uEvent = [[type, param1, param2]]; ag(l(a), ak, EVENT_MILLIS);

        return true;
    }; var bu = function (queryString) {
        var da = queryString.indexOf('?');

        if (da >= 0)queryString = queryString.substr(da + 1); var du = {},
            gc = queryString.split('&');

        for (var i = 0; i < gc.length; i++) {
            var aa = gc[i].split('=');

            if (aa[1])du[aa[0]] = aa[1]; else du[aa[0]] = '';
        }

        return du;
    }; var gr = function () { an(); eo(); if (window.addEventListener) { window.addEventListener('pageshow', function (event) { if (event.persisted)cz(); }, false); } };

    gr();
})();



/** WEBPACK FOOTER **
 ** ./legacy/others/a3320_tracking.js
 **/